module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0BAMAAAA3VgbYAAAAFVBMVEUAAADW3f/W3f/W3f/W3v/X3//W3f8/Xug/AAAABnRSTlMAf+/fb18EXGjhAAAAmElEQVQ4y93Tuw2AMAxFUdggFRMAEwADgMQAMAEfef8R6PJMbuE+qeKYg/Kxm5rHMf3jdc7TxZLPtHbn+WiXT3X25Pluljyy1weXR5YY6TswoBwDaQFIK0BiQGJAYkJkQmBCYEJgQmBCYYo/jLfBzYdHji+K10tExqckImPZEJGxRIPCjtphKZrI91fZeuqvs/+fchuaiscHcCRFu0iQ6h0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/public/closeIcon.png
// module id = /V6j
// module chunks = 0